import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    openEnd: {
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)),
        composes: "open-end",
        margin: ({ gridRendering }) => [[12, gridRendering ? "auto" : 0]],
        maxWidth: ({ theme, size, useModernTheme }) =>
            useModernTheme ? "100%" : Mixins.inputMaxWidth(theme, size, "Full"),
        minWidth: ({ theme, size, useModernTheme }) =>
            useModernTheme ? undefined : Mixins.inputMinWidth(theme, size, "Full"),
        width: ({ useModernTheme }) => (useModernTheme ? "100%" : undefined),
    },
    openEndError: {
        composes: "open-end--error",
    },
});
